module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\">Open An Example File</h3>\n</div>\n<div class=\"modal-body\">\n  <p>Pick one of the examples</p>\n  <select ng-options=\"file for file in files\" ng-model=\"selectedFile\" autofocus></select>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-warning\" ng-click=\"cancel()\">Cancel</button>\n  <button class=\"btn btn-primary\" ng-click=\"open(selectedFile)\">Open</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/open-examples.html
 ** module id = 398
 ** module chunks = 0
 **/